(() => {
  if (window.VintageSzafaPWA) return;
  const host = document.querySelector('[data-vs-pwa]');
  if (!host) return;
  window.VintageSzafaPWA = { version: '0.3.0-preview' };
  const base = host.dataset.vsPwa.replace(/\/$/, '');
  const appleMobile = /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const standalone = () => navigator.standalone === true || matchMedia('(display-mode: standalone)').matches;
  let config, registration, installPrompt, busy = false, existing = null;
  const dialog = document.createElement('dialog');
  dialog.className = 'vs-pwa-dialog';
  dialog.setAttribute('aria-labelledby', 'vs-pwa-heading');
  dialog.innerHTML = '<form method="dialog"><button class="vs-pwa-close" aria-label="Zamknij">×</button></form><span class="vs-pwa-eyebrow">VINTAGE SZAFA</span><h2 id="vs-pwa-heading">Twój skrót do nowego dropu.</h2><div data-pwa-install><p>Dodaj Vintage Szafę do ekranu telefonu. Otworzysz sklep z własnej ikony.</p><ol><li>Otwórz tę stronę w Safari.</li><li>Wybierz Udostępnij → Do ekranu początkowego.</li><li>Włącz „Otwórz jako aplikację”, jeśli ta opcja jest widoczna, i wybierz Dodaj.</li><li>Otwórz Vintage Szafę z nowej ikony, aby zapisać się na powiadomienia.</li></ol><button type="button" class="vs-pwa-primary" data-pwa-android hidden>Dodaj do ekranu</button></div><div data-pwa-push hidden><p>Nowy drop? Damy Ci znać. Kliknięcie powiadomienia otworzy aktualną dostawę.</p><button type="button" class="vs-pwa-primary" data-pwa-subscribe disabled>Przygotowuję powiadomienia…</button><button type="button" class="vs-pwa-secondary" data-pwa-unsubscribe hidden>Wyłącz powiadomienia na tym urządzeniu</button><p class="vs-pwa-note">Zapis dotyczy powiadomień o dropach. Możesz go wyłączyć tutaj lub w ustawieniach telefonu.</p></div><p data-pwa-status role="status" aria-live="polite"></p>';
  const promoTemplate = document.getElementById('vs-pwa-dialog-template');
  if (promoTemplate instanceof HTMLTemplateElement) {
    dialog.replaceChildren(promoTemplate.content.cloneNode(true));
    dialog.classList.add('vs-app-dialog');
  }
  document.body.append(dialog);
  const $ = selector => dialog.querySelector(selector);
  const status = message => { $('[data-pwa-status]').textContent = message; };
  const subscribeButton = $('[data-pwa-subscribe]');
  const unsubscribeButton = $('[data-pwa-unsubscribe]');
  const guide = $('vs-install-guide');
  const nativeInstall = $('[data-pwa-android]');
  let preparedSubscribed = false, hasOpened = false;
  const rememberWelcome = () => { try { localStorage.setItem('vs-pwa-welcome-v1', '1'); } catch {} };
  const setSubscribed = value => {
    subscribeButton.hidden = value;
    unsubscribeButton.hidden = !value;
    subscribeButton.disabled = false;
    subscribeButton.textContent = 'Powiadom mnie o dropach';
  };
  const api = async (resource, payload) => {
    const response = await fetch(base + '/' + resource, { credentials: 'same-origin', cache: 'no-store',
      ...(payload ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) } : {}) });
    if (!response.ok) throw new Error('api_unavailable');
    return response.json();
  };
  const applicationKey = value => {
    const bytes = atob(value.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - value.length % 4) % 4));
    return Uint8Array.from(bytes, c => c.charCodeAt(0));
  };
  const active = reg => new Promise((resolve, reject) => {
    if (reg.active) return resolve(reg);
    const worker = reg.installing || reg.waiting;
    if (!worker) return reject(new Error('worker_unavailable'));
    const timer = setTimeout(() => { worker.removeEventListener('statechange', check); reject(new Error('worker_timeout')); }, 15000);
    function check() {
      if (worker.state === 'activated' || worker.state === 'redundant') {
        clearTimeout(timer); worker.removeEventListener('statechange', check);
        if (worker.state === 'activated') resolve(reg); else reject(new Error('worker_redundant'));
      }
    }
    worker.addEventListener('statechange', check); check();
  });
  async function prepare() {
    if ((guide || appleMobile) && !standalone()) return;
    if (!isSecureContext || !('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
      subscribeButton.disabled = true; subscribeButton.textContent = 'Powiadomienia są niedostępne w tej przeglądarce'; return;
    }
    if (Notification.permission === 'denied') {
      subscribeButton.disabled = true; subscribeButton.textContent = 'Powiadomienia są zablokowane';
      status('Zmień zgodę w ustawieniach powiadomień dla Vintage Szafy na telefonie.'); return;
    }
    try {
      config = await api('config');
      registration = await active(await navigator.serviceWorker.register(base + '/sw.js', { scope: base + '/', updateViaCache: 'none' }));
      existing = await registration.pushManager.getSubscription();
      const saved = existing ? await api('subscription', { intent: 'status', subscription: existing.toJSON() }) : { subscribed: false };
      preparedSubscribed = saved.subscribed;
      setSubscribed(saved.subscribed);
      if (saved.subscribed) status('Gotowe. To urządzenie jest zapisane na powiadomienia o dropach.');
    } catch {
      subscribeButton.disabled = true; subscribeButton.textContent = 'Nie udało się przygotować zapisu';
      status('Spróbuj ponownie po otwarciu aplikacji. Zapis nie został potwierdzony.');
    }
  }
  const updateNativeInstall = () => {
    nativeInstall.hidden = !installPrompt || standalone() || Boolean(guide && (guide.dataset.platform !== 'android' || guide.dataset.step !== '0'));
  };
  dialog.addEventListener('vs:pwa-guide-change', updateNativeInstall);
  window.addEventListener('beforeinstallprompt', event => { event.preventDefault(); installPrompt = event; updateNativeInstall(); });
  nativeInstall.addEventListener('click', async () => {
    if (!installPrompt) return;
    const prompt = installPrompt;
    installPrompt = null;
    updateNativeInstall();
    try { await prompt.prompt(); await prompt.userChoice; } catch {}
  });
  window.addEventListener('appinstalled', () => { installPrompt = null; updateNativeInstall(); });
  if (!appleMobile) {
    const list = $('[data-pwa-install] ol');
    if (list) list.innerHTML = '<li>W menu przeglądarki wybierz „Zainstaluj aplikację” lub „Dodaj do ekranu głównego”.</li><li>Otwórz Vintage Szafę z nowej ikony.</li>';
  }
  const show = (shouldPrepare = true) => {
    if (dialog.open) return;
    hasOpened = true;
    const pushView = standalone() || (!guide && !appleMobile);
    $('[data-pwa-install]').hidden = standalone();
    $('[data-pwa-push]').hidden = !pushView;
    const heading = $('#vs-pwa-heading');
    if (guide) heading.textContent = standalone() ? heading.dataset.pushHeading : heading.dataset.installHeading;
    const reward = $('[data-pwa-reward]');
    if (reward) reward.hidden = !standalone();
    updateNativeInstall();
    dialog.showModal();
    if (guide && standalone()) rememberWelcome();
    if (shouldPrepare) prepare();
  };
  window.VintageSzafaPWA.open = show;
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-vs-pwa-open]');
    if (!trigger) return;
    event.preventDefault();
    show();
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  if (guide && standalone() && host.dataset.pwaDesignMode !== 'true') {
    let welcomed = false;
    try { welcomed = localStorage.getItem('vs-pwa-welcome-v1') === '1'; } catch {}
    if (!welcomed) {
      prepare().then(() => {
        if (preparedSubscribed) { rememberWelcome(); return; }
        if (hasOpened) return;
        show(false);
      });
    }
  }
  subscribeButton.addEventListener('click', () => {
    if (busy || !registration?.active || !config) return;
    busy = true; subscribeButton.disabled = true; status('Czekam na zgodę i zapis urządzenia…');
    let pending;
    try {
      pending = existing ? Promise.resolve(existing) : registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: applicationKey(config.publicKey) });
    } catch (error) { pending = Promise.reject(error); }
    pending.then(async subscription => {
      existing = subscription;
      await api('subscription', { intent: 'subscribe', consent: 'drops-v1', subscription: subscription.toJSON() });
      setSubscribed(true); status('Gotowe. Będziemy dawać Ci znać o nowych dropach.');
    }).catch(error => {
      setSubscribed(false);
      if (Notification.permission === 'denied') { subscribeButton.disabled = true; status('Zgoda została wyłączona. Możesz ją zmienić w ustawieniach telefonu.'); }
      else status(error.name === 'NotAllowedError' ? 'Zgoda nie została udzielona. Możesz wrócić do zapisu później.' : 'Nie udało się potwierdzić zapisu. Spróbuj ponownie.');
    }).finally(() => { busy = false; if (Notification.permission !== 'denied') subscribeButton.disabled = false; });
  });
  unsubscribeButton.addEventListener('click', async () => {
    if (busy || !existing) return;
    busy = true; unsubscribeButton.disabled = true;
    try {
      await api('subscription', { intent: 'unsubscribe', subscription: existing.toJSON() });
      await existing.unsubscribe(); existing = null; setSubscribed(false); status('Powiadomienia na tym urządzeniu zostały wyłączone.');
    } catch { status('Nie udało się potwierdzić wyłączenia. Spróbuj ponownie.'); }
    finally { busy = false; unsubscribeButton.disabled = false; }
  });
})();
